// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"8bb31a13","64":"27babbfc","217":"a816633d","387":"6f4281b2","453":"0003163f","573":"20fbea0e","625":"8b39fc41","681":"36c40cc2","793":"b4774a5f","799":"1254ad67","840":"a8d99820","983":"fcb92020"}[chunkId] + ".chunk.js";
};